import { render, staticRenderFns } from "./addRisName.vue?vue&type=template&id=205a8940&scoped=true&"
import script from "./addRisName.vue?vue&type=script&lang=js&"
export * from "./addRisName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a8940",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205a8940')) {
      api.createRecord('205a8940', component.options)
    } else {
      api.reload('205a8940', component.options)
    }
    module.hot.accept("./addRisName.vue?vue&type=template&id=205a8940&scoped=true&", function () {
      api.rerender('205a8940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/risk/dialogs/addRisName.vue"
export default component.exports